(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["state-laws-map"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var stateData = {
      "US-AL": { name: "Alabama", felon: true, permit: false, restrictions: false, details: ["Legal for lawful residents.", "Felons are prohibited from ownership.", "Purchases allowed both online and in person."] },
      "US-AK": { name: "Alaska", felon: true, permit: false, restrictions: false, details: ["Legal for lawful residents.", "Felons are prohibited from ownership.", "Purchases allowed both online and in person."] },
      "US-AZ": { name: "Arizona", felon: true, permit: false, restrictions: true, details: ["Legal for lawful residents.", "Felons are prohibited from ownership.", "Class 4 felony to commit a felony while wearing body armor.", "Purchases allowed both online and in person."] },
      "US-AR": { name: "Arkansas", felon: true, permit: false, restrictions: true, details: ["Legal for lawful residents.", "Felons are prohibited from ownership.", "Class A misdemeanor for felons convicted of murder, manslaughter, robbery, assault, or battery.", "Purchases allowed both online and in person."] },
      "US-CA": { name: "California", felon: true, permit: false, restrictions: true, details: ["Legal for lawful residents.", "Prohibited for those banned from firearm possession.", "Wearing body armor during a crime adds 1 to 5 years to sentence.", "Purchases allowed both online and in person."] },
      "US-CO": { name: "Colorado", felon: true, permit: false, restrictions: false, details: ["Legal for lawful residents.", "Felons are prohibited from ownership.", "Purchases allowed both online and in person."] },
      "US-CT": { name: "Connecticut", felon: true, permit: false, restrictions: true, details: ["Legal for lawful residents.", "Felons are prohibited from ownership.", "Must be purchased in person only — online sales are a Class B misdemeanor.", "Face-to-face transaction required for all purchases."] },
      "US-DE": { name: "Delaware", felon: true, permit: false, restrictions: true, details: ["Legal for lawful residents.", "Felons are prohibited from ownership.", "Class B felony to wear body armor while committing or attempting a felony.", "Purchases allowed both online and in person."] },
      "US-DC": { name: "District of Columbia", felon: true, permit: false, restrictions: false, details: ["Legal for lawful residents.", "Federal felon prohibition applies.", "Purchases allowed both online and in person."] },
      "US-FL": { name: "Florida", felon: true, permit: false, restrictions: true, details: ["Legal for lawful residents.", "Felons are prohibited from ownership.", "Third-degree felony for wearing during serious crimes like murder and robbery.", "Purchases allowed both online and in person."] },
      "US-GA": { name: "Georgia", felon: true, permit: false, restrictions: true, details: ["Legal for lawful residents.", "Felons are prohibited from ownership.", "Felony to wear during violent crime or drug trafficking.", "Purchases allowed both online and in person."] },
      "US-HI": { name: "Hawaii", felon: true, permit: false, restrictions: false, details: ["Legal for lawful residents.", "Felons are prohibited from ownership.", "Purchases allowed both online and in person."] },
      "US-ID": { name: "Idaho", felon: true, permit: false, restrictions: false, details: ["Legal for lawful residents.", "Felons are prohibited from ownership.", "Purchases allowed both online and in person."] },
      "US-IL": { name: "Illinois", felon: true, permit: false, restrictions: true, details: ["Legal for lawful residents.", "Felons are prohibited from ownership.", "Class A misdemeanor for wearing body armor with a dangerous weapon during a crime.", "Purchases allowed both online and in person."] },
      "US-IN": { name: "Indiana", felon: true, permit: false, restrictions: true, details: ["Legal for lawful residents.", "Felons are prohibited from ownership.", "Level 6 felony for knowingly wearing body armor during felony commission.", "Purchases allowed both online and in person."] },
      "US-IA": { name: "Iowa", felon: true, permit: false, restrictions: false, details: ["Legal for lawful residents.", "Felons are prohibited from ownership.", "Purchases allowed both online and in person."] },
      "US-KS": { name: "Kansas", felon: true, permit: false, restrictions: true, details: ["Legal for lawful residents.", "Felons are prohibited from ownership.", "Topeka city ordinance prohibits wearing during protests and demonstrations.", "Purchases allowed both online and in person."] },
      "US-KY": { name: "Kentucky", felon: true, permit: false, restrictions: true, details: ["Legal for lawful residents.", "Felons are prohibited from ownership.", "Defendant wearing armor during felony is ineligible for parole.", "Purchases allowed both online and in person."] },
      "US-LA": { name: "Louisiana", felon: true, permit: false, restrictions: true, details: ["Legal for lawful residents.", "Felons are prohibited from ownership.", "Illegal to wear body armor on school property or in firearm-free zones.", "Purchases allowed both online and in person."] },
      "US-ME": { name: "Maine", felon: true, permit: false, restrictions: false, details: ["Legal for lawful residents.", "Felons are prohibited from ownership.", "Purchases allowed both online and in person."] },
      "US-MD": { name: "Maryland", felon: true, permit: true, restrictions: true, details: ["Legal for lawful residents.", "Felons are prohibited from ownership.", "Prior violence or drug trafficking convictions may petition Secretary of Maryland State Police for a permit.", "Purchases allowed both online and in person."] },
      "US-MA": { name: "Massachusetts", felon: true, permit: false, restrictions: true, details: ["Legal for lawful residents.", "Felons are prohibited from ownership.", "Felony to wear body armor during crime commission.", "Purchases allowed both online and in person."] },
      "US-MI": { name: "Michigan", felon: true, permit: true, restrictions: true, details: ["Legal for lawful residents.", "Felons are prohibited from ownership.", "Felony punishable by up to 4 years for wearing during violent acts.", "Employment-based exception possible for those with prior conviction.", "Purchases allowed both online and in person."] },
      "US-MN": { name: "Minnesota", felon: true, permit: false, restrictions: false, details: ["Legal for lawful residents.", "Felons are prohibited from ownership.", "Purchases allowed both online and in person."] },
      "US-MS": { name: "Mississippi", felon: true, permit: false, restrictions: false, details: ["Legal for lawful residents.", "Felons are prohibited from ownership.", "Purchases allowed both online and in person."] },
      "US-MO": { name: "Missouri", felon: true, permit: true, restrictions: true, details: ["Legal for lawful residents.", "Felons are prohibited from ownership.", "Employment-based exception possible for those with prior felony.", "Purchases allowed both online and in person."] },
      "US-MT": { name: "Montana", felon: true, permit: false, restrictions: false, details: ["Legal for lawful residents.", "Felons are prohibited from ownership.", "Purchases allowed both online and in person."] },
      "US-NE": { name: "Nebraska", felon: true, permit: false, restrictions: false, details: ["Legal for lawful residents.", "Felons are prohibited from ownership.", "Purchases allowed both online and in person."] },
      "US-NV": { name: "Nevada", felon: true, permit: false, restrictions: false, details: ["Legal for lawful residents.", "Felons are prohibited from ownership.", "Purchases allowed both online and in person."] },
      "US-NH": { name: "New Hampshire", felon: true, permit: false, restrictions: true, details: ["Legal for lawful residents.", "Felons are prohibited from ownership.", "Class B felony for committing any felony while wearing body armor.", "Purchases allowed both online and in person."] },
      "US-NJ": { name: "New Jersey", felon: true, permit: false, restrictions: true, details: ["Legal for lawful residents.", "Felons are prohibited from ownership.", "Separate charges and enhanced penalties for wearing during criminal acts.", "Purchases allowed both online and in person."] },
      "US-NM": { name: "New Mexico", felon: true, permit: false, restrictions: false, details: ["Legal for lawful residents.", "Felons are prohibited from ownership.", "Purchases allowed both online and in person."] },
      "US-NY": { name: "New York", felon: true, permit: false, restrictions: true, details: ["Restricted for civilians — must be purchased in person only.", "Online and mail-order sales are prohibited.", "Convicted felons are prohibited from ownership.", "Class E felony for wearing during a violent felony."] },
      "US-NC": { name: "North Carolina", felon: true, permit: false, restrictions: true, details: ["Legal for lawful residents.", "Felons are prohibited from ownership.", "Separate charge for wearing body armor during crime commission.", "Purchases allowed both online and in person."] },
      "US-ND": { name: "North Dakota", felon: true, permit: false, restrictions: false, details: ["Legal for lawful residents.", "Felons are prohibited from ownership.", "Purchases allowed both online and in person."] },
      "US-OH": { name: "Ohio", felon: true, permit: false, restrictions: false, details: ["Legal for lawful residents.", "Felons are prohibited from ownership.", "Purchases allowed both online and in person."] },
      "US-OK": { name: "Oklahoma", felon: true, permit: false, restrictions: true, details: ["Legal for lawful residents.", "Felons are prohibited from ownership.", "Felony to wear body armor during crime commission.", "Purchases allowed both online and in person."] },
      "US-OR": { name: "Oregon", felon: true, permit: false, restrictions: false, details: ["Legal for lawful residents.", "Felons are prohibited from ownership.", "Purchases allowed both online and in person."] },
      "US-PA": { name: "Pennsylvania", felon: true, permit: false, restrictions: false, details: ["Legal for lawful residents.", "Felons are prohibited from ownership.", "Purchases allowed both online and in person."] },
      "US-RI": { name: "Rhode Island", felon: true, permit: true, restrictions: true, details: ["Legal for lawful residents.", "Felons convicted of crimes of violence are prohibited from ownership (2012 law).", "Permit exception available.", "Purchases allowed both online and in person."] },
      "US-SC": { name: "South Carolina", felon: true, permit: false, restrictions: true, details: ["Legal for lawful residents.", "Felons are prohibited from ownership.", "Separate charge for wearing body armor during crime commission.", "Purchases allowed both online and in person."] },
      "US-SD": { name: "South Dakota", felon: true, permit: false, restrictions: false, details: ["Legal for lawful residents.", "Felons are prohibited from ownership.", "Purchases allowed both online and in person."] },
      "US-TN": { name: "Tennessee", felon: true, permit: false, restrictions: true, details: ["Legal for lawful residents.", "Felons are prohibited from ownership.", "Class E felony for wearing body armor during crime commission.", "Purchases allowed both online and in person."] },
      "US-TX": { name: "Texas", felon: true, permit: false, restrictions: false, details: ["Legal for lawful residents.", "Felons are prohibited from ownership.", "Purchases allowed both online and in person."] },
      "US-UT": { name: "Utah", felon: true, permit: false, restrictions: false, details: ["Legal for lawful residents.", "Felons are prohibited from ownership.", "Purchases allowed both online and in person."] },
      "US-VT": { name: "Vermont", felon: true, permit: false, restrictions: false, details: ["Legal for lawful residents.", "Felons are prohibited from ownership.", "Purchases allowed both online and in person."] },
      "US-VA": { name: "Virginia", felon: true, permit: false, restrictions: true, details: ["Legal for lawful residents.", "Felons are prohibited from ownership.", "Class 4 felony to possess body armor during a crime of violence with a firearm or knife.", "Purchases allowed both online and in person."] },
      "US-WA": { name: "Washington", felon: true, permit: false, restrictions: false, details: ["Legal for lawful residents.", "Felons are prohibited from ownership.", "Purchases allowed both online and in person."] },
      "US-WV": { name: "West Virginia", felon: true, permit: false, restrictions: true, details: ["Legal for lawful residents.", "Felons are prohibited from ownership.", "Felony for wearing body armor while committing a felony involving force or weapon.", "Purchases allowed both online and in person."] },
      "US-WI": { name: "Wisconsin", felon: true, permit: false, restrictions: true, details: ["Legal for lawful residents.", "Felons are prohibited from ownership.", "Additional felony conviction or extended sentence for wearing during crime.", "Purchases allowed both online and in person."] },
      "US-WY": { name: "Wyoming", felon: true, permit: false, restrictions: false, details: ["Legal for lawful residents.", "Felons are prohibited from ownership.", "Purchases allowed both online and in person."] }
    };

    var container = document.getElementById('us-map-container');
    var tooltip = document.getElementById('map-tooltip');
    var tooltipState = document.getElementById('tooltip-state');
    var tooltipRows = document.getElementById('tooltip-rows');
    var tooltipDetails = document.getElementById('tooltip-details');

    if (!container || !tooltip) return;

    var svgUrl = container.getAttribute('data-svg-url');
    if (!svgUrl) return;

    fetch(svgUrl)
      .then(function(response) { return response.text(); })
      .then(function(svgText) {
        container.innerHTML = svgText;
        initMap();
      });

    function createBadge(value) {
      var badge = document.createElement('span');
      badge.className = 'state-laws-map__tooltip-badge badge--' + (value ? 'yes' : 'no');
      badge.textContent = value ? 'Yes' : 'No';
      return badge;
    }

    function createRow(label, value) {
      var row = document.createElement('div');
      row.className = 'state-laws-map__tooltip-row';
      var labelEl = document.createElement('span');
      labelEl.className = 'state-laws-map__tooltip-row-label';
      labelEl.textContent = label;
      row.appendChild(labelEl);
      row.appendChild(createBadge(value));
      return row;
    }

    var isMobile = window.matchMedia('(max-width: 749px)').matches;

    function initMap() {
      var paths = container.querySelectorAll('svg path[id^="US-"]');

      if (isMobile) {
        paths.forEach(function(path) {
          path.style.cursor = 'default';
        });
        return;
      }

      paths.forEach(function(path) {
        var stateId = path.getAttribute('id');
        var data = stateData[stateId];
        if (!data) return;

        path.addEventListener('mouseenter', function(e) {
          tooltipState.textContent = data.name;

          tooltipRows.innerHTML = '';
          tooltipRows.appendChild(createRow('Felon Prohibition:', data.felon));
          tooltipRows.appendChild(createRow('Permit Exception:', data.permit));
          tooltipRows.appendChild(createRow('Additional Restrictions:', data.restrictions));

          tooltipDetails.innerHTML = '';
          data.details.forEach(function(detail) {
            var li = document.createElement('li');
            li.textContent = detail;
            tooltipDetails.appendChild(li);
          });

          tooltip.classList.add('is-visible');
          tooltip.setAttribute('aria-hidden', 'false');
          positionTooltip(e);
        });

        path.addEventListener('mousemove', function(e) {
          positionTooltip(e);
        });

        path.addEventListener('mouseleave', function() {
          tooltip.classList.remove('is-visible');
          tooltip.setAttribute('aria-hidden', 'true');
        });
      });
    }

    function positionTooltip(e) {
      var x = e.clientX + 16;
      var y = e.clientY + 16;
      var tooltipRect = tooltip.getBoundingClientRect();
      var viewportWidth = window.innerWidth;
      var viewportHeight = window.innerHeight;

      if (x + tooltipRect.width > viewportWidth - 16) {
        x = e.clientX - tooltipRect.width - 16;
      }
      if (y + tooltipRect.height > viewportHeight - 16) {
        y = e.clientY - tooltipRect.height - 16;
      }

      tooltip.style.left = x + 'px';
      tooltip.style.top = y + 'px';
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  class JudgemeTestimonials {
    constructor(section) {
      this.section = section;
      this.limit = parseInt(section.dataset.limit) || 10;
      this.minRating = parseInt(section.dataset.minRating) || 4;
      this.fetchReviews();
    }

    async fetchReviews() {
      try {
        // Use Vercel proxy (credentials stored server-side)
        const proxyUrl = `https://judgeme-proxy-ajy9.vercel.app/api/reviews?per_page=${this.limit * 2}&min_rating=${this.minRating}`;
        const response = await fetch(proxyUrl);

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();

        if (data.reviews && data.reviews.length > 0) {
          const filteredReviews = data.reviews
            .filter(review => review.rating >= this.minRating)
            .slice(0, this.limit);

          if (filteredReviews.length > 0) {
            this.renderReviews(filteredReviews);
          } else {
            this.showError('No reviews match the criteria');
          }
        } else {
          this.showError('No reviews found');
        }
      } catch (error) {
        console.error('Judge.me API Error:', error);
        this.showError('Failed to load reviews');
      }
    }

    renderReviews(reviews) {
      const leftColumn = this.section.querySelector('[data-column="left"]');
      const leftDuplicate = this.section.querySelector('[data-column="left-duplicate"]');
      const rightColumn = this.section.querySelector('[data-column="right"]');
      const rightDuplicate = this.section.querySelector('[data-column="right-duplicate"]');
      const mobileColumn = this.section.querySelector('[data-column="mobile"]');
      const mobileDuplicate = this.section.querySelector('[data-column="mobile-duplicate"]');

      const evenReviews = reviews.filter((_, i) => i % 2 === 0);
      const oddReviews = reviews.filter((_, i) => i % 2 === 1);

      // Render desktop columns
      if (leftColumn) {
        leftColumn.innerHTML = evenReviews.map(r => this.createCard(r)).join('');
      }
      if (leftDuplicate) {
        leftDuplicate.innerHTML = evenReviews.map(r => this.createCard(r)).join('');
      }
      if (rightColumn) {
        rightColumn.innerHTML = oddReviews.map(r => this.createCard(r)).join('');
      }
      if (rightDuplicate) {
        rightDuplicate.innerHTML = oddReviews.map(r => this.createCard(r)).join('');
      }

      // Render mobile
      if (mobileColumn) {
        mobileColumn.innerHTML = reviews.map(r => this.createCard(r)).join('');
      }
      if (mobileDuplicate) {
        mobileDuplicate.innerHTML = reviews.map(r => this.createCard(r)).join('');
      }

      // Mark as loaded
      this.section.setAttribute('data-loaded', '');
    }

    createCard(review) {
      const name = review.reviewer?.name || 'Customer';
      const rating = review.rating || 5;
      const text = review.body || '';
      const date = this.formatDate(review.created_at);
      const initial = name.charAt(0).toUpperCase();

      const stars = Array.from({ length: 5 }, (_, i) => `
        <svg class="testimonial-card__star ${i < rating ? 'testimonial-card__star--filled' : ''}" width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
          <path d="M10 1l2.47 6.1 6.53.53-5 4.36 1.5 6.51L10 15.27 4.5 18.5l1.5-6.51-5-4.36 6.53-.53L10 1z"/>
        </svg>
      `).join('');

      return `
        <div class="testimonial-card">
          <div class="testimonial-card__rating">${stars}</div>
          ${text ? `<p class="testimonial-card__text">${this.escapeHtml(text)}</p>` : ''}
          <div class="testimonial-card__author">
            <div class="testimonial-card__avatar">
              <div class="testimonial-card__avatar-placeholder">${initial}</div>
            </div>
            <div class="testimonial-card__author-info">
              <span class="testimonial-card__name">${this.escapeHtml(name)}</span>
              ${date ? `<span class="testimonial-card__date">${date}</span>` : ''}
            </div>
          </div>
        </div>
      `;
    }

    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      const options = { year: 'numeric', month: 'short', day: 'numeric' };
      return date.toLocaleDateString('en-US', options);
    }

    escapeHtml(text) {
      const div = document.createElement('div');
      div.textContent = text;
      return div.innerHTML;
    }

    showError(message) {
      const loading = this.section.querySelector('[data-loading]');
      if (loading) {
        loading.innerHTML = `<span>${message}</span>`;
      }
    }
  }

  // Initialize on DOM ready
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-judgeme-testimonials]').forEach(section => {
      new JudgemeTestimonials(section);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
